import { Container } from './container';
import { Flag } from './flag';
import { Name } from './name';

export const StyleLayout = {
  Container,
  Flag,
  Name
};
